import React from "react"
import ErrorPage from "./ErrorPage/ErrorPage"
const browser = typeof window !== "undefined" && window

const ChilimaniaErrorPage = () => browser && <ErrorPage />

export default ChilimaniaErrorPage
